import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { VisitorStatus } from '@/models'

export type VendorDetailsResponse = {
  visitor: {
    notes?: string
    name?: string
    status: VisitorStatus
    email?: string
    phone?: string
    company?: string
    bannedReason?: string
    startTime?: string
    endTime?: string
    createdBy?: string
    permissionToEnter?: boolean
    coi?: string
    // Note: As it was described in EL-14633 - keylessAccess is temporarly treated as physical key access,
    // and keyAccess is treated as keyless integration
    keylessAccess?: boolean
    pinCode?: boolean
    customAccess?: boolean
    vendorId?: string | number
    guestId?: string | number
  }
  checkIns: { date: string | number }[]
}

export const getVendorDetailsQueryKey = (vendorId: number) => ['useGetVendorDetails', { vendorId }]

export const getVendorDetails = async (vendorId: number): Promise<VendorDetailsResponse> => {
  const response = await authAPI.get<VendorDetailsResponse>(`/vendor/${vendorId}`)
  return response.data
}

export const useGetVendorDetails = (vendorId: number) => {
  return useQuery({
    gcTime: 0,
    queryFn: () => getVendorDetails(vendorId),
    queryKey: getVendorDetailsQueryKey(vendorId),
  })
}
